var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.68344 2.94904C5.09339 2.94904 4.61506 3.42737 4.61506 4.01742V15.9832C4.61506 16.5733 5.09339 17.0516 5.68343 17.0516H14.2304C14.8205 17.0516 15.2988 16.5733 15.2988 15.9832V7.79025C15.2988 7.73358 15.2763 7.67923 15.2362 7.63916L10.6087 3.01163C10.5686 2.97156 10.5143 2.94904 10.4576 2.94904H5.68344ZM3.33301 4.01742C3.33301 2.71931 4.38533 1.66699 5.68344 1.66699H10.4576C10.8543 1.66699 11.2347 1.82458 11.5153 2.10508L16.1428 6.73261C16.4233 7.01312 16.5809 7.39356 16.5809 7.79025V15.9832C16.5809 17.2813 15.5286 18.3337 14.2304 18.3337H5.68343C4.38533 18.3337 3.33301 17.2813 3.33301 15.9832V4.01742ZM6.75181 10.0003C6.75181 9.6463 7.03881 9.3593 7.39284 9.3593H12.521C12.8751 9.3593 13.1621 9.6463 13.1621 10.0003C13.1621 10.3544 12.8751 10.6414 12.521 10.6414H7.39284C7.03881 10.6414 6.75181 10.3544 6.75181 10.0003ZM6.75181 13.4191C6.75181 13.0651 7.03881 12.7781 7.39284 12.7781H12.521C12.8751 12.7781 13.1621 13.0651 13.1621 13.4191C13.1621 13.7732 12.8751 14.0602 12.521 14.0602H7.39284C7.03881 14.0602 6.75181 13.7732 6.75181 13.4191Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile3);
export default __webpack_public_path__ + "static/media/file-3.71a829cd110ffc62631196d5ebe616e3.svg";
export { ForwardRef as ReactComponent };